import { Record } from "immutable";

const defaults = {
    _id: "",
    id: "",
    event_type: "tradeshow",
    name: "",
    slug: "",
    type: "tradeshow",
};

class EventRecord extends Record(defaults) {}

export default EventRecord;
